import * as yup from 'yup';
import { findCountryByValue, getDefaultPhone, getMask } from '../components/Form/Custom/CustomPhoneInput/helpers';

export const MIN_VALID = (length: number) => ({
  message: 'validation.error.more.than.characters',
  value: { count: length },
});
export const MAX_VALID = (length: number) => ({
  message: 'validation.error.less.than.characters',
  value: { count: length },
});

export const REQUIRE_VALID = 'validation.error.required';
export const EMAIL_VALID = 'validation.error.email.invalid';
export const DATE_INVALID = 'validation.error.date.invalid';

export const mobilePhoneSchema = yup.string().test((value: any) => {
  const country = findCountryByValue(value);
  const phone = getDefaultPhone(value);
  const mask = getMask(phone, country);

  if (!mask) return true;
  const cleanMask = mask.replace(/[^\d]/g, '');
  return phone.length === cleanMask.length;
});
